export function ChatIcon(props: React.SVGProps<SVGSVGElement>): JSX.Element {
  return (
    <svg width='16' height='16' viewBox='0 0 16 16' fill='none' xmlns='http://www.w3.org/2000/svg' {...props}>
      <path
        d='M5.33333 8.0013H5.34M8 8.0013H8.00667M10.6667 8.0013H10.6733M14 8.0013C14 10.9468 11.3137 13.3346 8 13.3346C6.97382 13.3346 6.00781 13.1056 5.16311 12.702L2 13.3346L2.92999 10.8547C2.34104 10.0295 2 9.05082 2 8.0013C2 5.05578 4.68629 2.66797 8 2.66797C11.3137 2.66797 14 5.05578 14 8.0013Z'
        stroke='currentColor'
        strokeWidth='1.5'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
    </svg>
  )
}
